


























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import InvestmentHistoryItem from "@/shared/components/investments/InvestmentHistoryItem.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import _ from "lodash";
import { Location } from "vue-router";
import { useInvestmentHistoryStore } from "@/shared/store/investmentHistory";

@Component({
  components: {
    Widget,
    InvestmentHistoryItem,
    Pagination
  }
})
export default class InvestmentTransferHistoryWidget extends Vue {
  investmentHistoryStore = useInvestmentHistoryStore();

  @Prop()
  page: number;

  @Prop()
  routeToPages: (page) => Location;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  mounted () {
    this.loadPage();
  }

  get isLoading () {
    return this.investmentHistoryStore.fetchState === FetchState.Uninitialized ||
        this.investmentHistoryStore.fetchState === FetchState.Loading;
  }

  get showNoTxs () {
    return this.investmentHistoryStore.fetchState === FetchState.Loaded &&
        this.investmentHistoryStore.historyForCurrentPage &&
        this.investmentHistoryStore.historyForCurrentPage.length === 0;
  }

  get isLoaded () {
    return this.investmentHistoryStore.fetchState === FetchState.Loaded
        && !this.showNoTxs;
  }

  @Watch("$props", { deep: true })
  loadPage () {
    this.investmentHistoryStore.loadHistory({
      pageNumber: this.page,
      username: this.username,
      partnerId: this.partnerId
    } as any).catch(() => null); // the store rethrows the error
    this.investmentHistoryStore.setHistoryPageNumber(this.page);
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToPages(toPage));
  }

  get pageButtonsStartValue (): number {
    return this.page - 2 > 0 ? this.page - 2 : 1;
  }

  get pageButtonRange (): number[] {
    const endValue = this.page + 3 < this.investmentHistoryStore.historyPageCount ?
        (this.page + 3) : (this.investmentHistoryStore.historyPageCount + 1);
    return _.range(this.pageButtonsStartValue, endValue);

  }
}

